module.exports = __webpack_public_path__ + "img/item-01.2a6d19f0.png";